import styled from 'styled-components'
import { color } from '../../GlobalStyle'

export const Table = styled.table`
  width: 100%;
  thead {
    border-bottom: 3px solid rgba(0, 0, 0.4);
  }
  tbody {
    position: relative;
  }
  th {
    text-align: initial;
    padding: 10px;
  }
  td {
    button {
      margin: 0 auto;
    }

    .lineAbove {
      margin: 1vh 0px;
      border-top: 1px solid rgba(0, 0, 0, 0.15);
      background: red;
    }
  }
`
export const Total = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 2vh;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
`
export const TotalTitle = styled.p`
  font-weight: bold;

  text-transform: uppercase;
`
export const Format = styled.p`
  font-weight: bold;
  margin-left: ${(props) => (props.sale ? '30px' : '0px')};
`
export const MonthButton = styled.button`
  position: absolute;
  display: flex;
  top: 50%;
  font-size: 23px;
  color: white;
  border-radius: 360px;
  transform: translateY(-50%);
  padding: 3px;
  background-color: ${color.brand};
  ${(props) =>
    props.plus
      ? `
    margin-left:-30px;
  `
      : `right:0;
     margin-right:-30px;`};
`
export const TotalText = styled.p`
  font-size: 40px;
  color: ${color.brand};
  span {
    color: ${({ theme }) => theme.primary};
    font-size: 30px;
  }
`

export const Manual = styled.div`
  margin-top: 2vh;
  p {
    font-weight: bold;
    margin-bottom: 5px;
  }
`
